import { utils as tkUtils } from '@adc/ui-core'
import moment from 'moment'

const { date } = tkUtils.formValidators
const MAXIMUM_AGE = 150
const MINIMUM_REQUIRED_AGE = 18
export const over18 = () =>
  date({
    format: 'mm/dd/yyyy',
    '<=': eighteenYearsAgo,
    '>=': oneFiftyYearsAgo,
    msg: 'Sorry, you must be at least 18 years old',
  })

const eighteenYearsAgo = () => {
  return moment().subtract(MINIMUM_REQUIRED_AGE, 'years')
}
const oneFiftyYearsAgo = () => {
  return moment().subtract(MAXIMUM_AGE, 'years')
}
